import { useEffect, useState } from 'react';

import { generatePath } from 'react-router-dom';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import Link from '@zenbusiness/zui/Link';
import SharedAsset from '@zenbusiness/zui/SharedAsset';

import * as ROUTES from '#client/constants/routes';

/**
 * Logo
 *
 * TODO: Make this a shared component with the AppHeaderLogo.
 *
 * @returns {import('react').ReactNode}
 */
function Logo() {
  const { businessEntityUuid } = useBusinessEntity();
  const [logoPath, setLogoPath] = useState(ROUTES.dashboard);
  const assetSrc = '/s2/vector/zb-bug-color-2022-wb.svg';

  const handleOnClick = () => {
    // Allow nav to shrink on mouseOut.
    document.activeElement.blur();
  };

  useEffect(() => {
    if (businessEntityUuid) {
      setLogoPath(generatePath(ROUTES.entity, { businessEntityUuid }));
    }
  }, [businessEntityUuid]);

  return (
    <Link
      aria-label="Return to dashboard"
      clickstreamProps={{
        elementAsset: assetSrc,
        elementName: 'entity_nav_logo',
        destination: ROUTES.dashboard
      }}
      onClick={handleOnClick}
      tabIndex={0}
      to={logoPath}
    >
      <SharedAsset
        alt="ZenBusiness Inc."
        src={assetSrc}
        width={44}
      />
    </Link>
  );
}

export default Logo;
